import React__default from 'react';
import { SelectionSetTileImageContainer, FluidImage } from '@vp/swan';

const ImageTileThumbnail = ({ choice }) => {
    if (!choice.image) {
        return null;
    }
    return (React__default.createElement(SelectionSetTileImageContainer, { style: { height: "unset" } },
        React__default.createElement(FluidImage, { alt: "", src: choice.image })));
};

export { ImageTileThumbnail };
//# sourceMappingURL=image-thumbnail.mjs.map
